import moment from 'moment';

export interface NotificationGroup {
  id: string;
  label: string;
  items: any[];
}

const sortByReceivedDesc = (a: any, b: any) => {
  const am = moment.utc(a?.receivedDate);
  const bm = moment.utc(b?.receivedDate);
  const av = am.isValid() ? am.valueOf() : 0;
  const bv = bm.isValid() ? bm.valueOf() : 0;
  return bv - av;
};

export const groupByDate = (
  notifications: any[],
  labels: { today: string; yesterday: string; last7Days: string; older: string }
): NotificationGroup[] => {
  const startOfToday = moment().startOf('day');
  const startOfYesterday = moment().subtract(1, 'day').startOf('day');
  const startOfLast7Days = moment().subtract(7, 'day').startOf('day');

  const today: any[] = [];
  const yesterday: any[] = [];
  const last7Days: any[] = [];
  const older: any[] = [];

  (notifications || []).forEach((n) => {
    const m = moment.utc(n?.receivedDate).local();
    if (m.isValid() && m.isSameOrAfter(startOfToday)) {
      today.push(n);
    } else if (m.isValid() && m.isSameOrAfter(startOfYesterday)) {
      yesterday.push(n);
    } else if (m.isValid() && m.isSameOrAfter(startOfLast7Days)) {
      last7Days.push(n);
    } else {
      older.push(n);
    }
  });

  return [
    { id: 'today', label: labels.today, items: today.sort(sortByReceivedDesc) },
    { id: 'yesterday', label: labels.yesterday, items: yesterday.sort(sortByReceivedDesc) },
    { id: 'last7days', label: labels.last7Days, items: last7Days.sort(sortByReceivedDesc) },
    { id: 'older', label: labels.older, items: older.sort(sortByReceivedDesc) },
  ].filter((g) => g.items.length > 0);
};

export const groupByApplication = (
  notifications: any[],
  applications: any[],
  otherLabel: string
): NotificationGroup[] => {
  const OTHER = '__other__';
  const groups: Record<string, NotificationGroup> = {};

  const resolveName = (code: string): string => {
    const app = (applications || []).find(
      (a: any) => a?.appId === code || a?.id === code
    );
    return app?.name || code;
  };

  (notifications || []).forEach((n) => {
    const codes = n?.target?.application;
    const hasApp = Array.isArray(codes) && codes.length > 0;
    if (!hasApp) {
      if (!groups[OTHER]) groups[OTHER] = { id: OTHER, label: otherLabel, items: [] };
      groups[OTHER].items.push(n);
      return;
    }
    Array.from(new Set(codes.map(String))).forEach((code) => {
      if (!groups[code]) {
        groups[code] = { id: code, label: resolveName(code), items: [] };
      }
      groups[code].items.push(n);
    });
  });

  const result = Object.values(groups);
  result.forEach((g) => g.items.sort(sortByReceivedDesc));
  result.sort((a, b) => {
    if (a.id === OTHER) return 1;
    if (b.id === OTHER) return -1;
    return a.label.localeCompare(b.label);
  });
  return result;
};
